import {
  mdiDotsSquare,
  mdiAccountClockOutline,
  mdiScriptTextOutline,
  mdiDatabaseOutline,
  mdiCogs,
  mdiFileChartOutline,
  mdiChartBoxOutline,
  mdiCalculator,
  mdiViewList,
  mdiChartBar,
  mdiFileChartPlusOutline,
} from '@mdi/js'
import { format } from 'date-fns'
import useCurrentData from '@/views/composable/useCurrentData'

const { currentClub, userAbilities } = useCurrentData()

export default [
  {
    title: 'ホール',
    icon: mdiDotsSquare,
    to: {
      name: 'waiter-halls',
      params: {
        club_slug: currentClub.value?.slug,
      },
    },
    resource: 'Waiter',
  },
  {
    title: 'オーダー',
    icon: mdiScriptTextOutline,
    to: {
      name: 'waiter-orders',
      params: {
        club_slug: currentClub.value?.slug,
      },
    },
    resource: 'Waiter',
  },
  {
    title: '勤怠/待機',
    icon: mdiAccountClockOutline,
    to: {
      name: 'waiter-timecards',
      params: {
        club_slug: currentClub.value?.slug,
      },
    },
    resource: 'Waiter',
  },
  (
    userAbilities.value?.findIndex(a => a.subject === 'eod_closing') >= 0
      ? {
        title: '日報',
        icon: mdiFileChartOutline,
        to: {
          name: 'eod-report',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'eod_closing',
        action: 'manage',
      }
      : {
        title: '日報',
        icon: mdiFileChartOutline,
        to: {
          name: 'waiter-daily-reports',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'Admin',
      }
  ),
  {
    title: '日報β',
    icon: mdiChartBoxOutline,
    to: {
      name: 'daily-report-summary',
      params: {
        club_slug: currentClub.value?.slug,
      },
    },
    resource: 'Admin',
  },
  {
    title: 'データ',
    icon: mdiDatabaseOutline,
    to: {
      name: 'waiter-data',
      params: {
        club_slug: currentClub.value?.slug,
      },
    },
    resource: 'Waiter',
  },
  {
    title: '設定',
    icon: mdiCogs,
    children: [
      {
        title: 'ホール',
        to: {
          name: 'waiter-settings-halls',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'Waiter',
      },
      {
        title: 'メニュー',
        to: {
          name: 'waiter-settings-vendibles',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'Waiter',
      },
      {
        title: '商品タグ',
        to: {
          name: 'waiter-settings-vendible-tags',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'Waiter',
      },
      {
        title: '在庫管理',
        to: {
          name: 'admin-inventory',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'inventory',
        action: 'manage',
      },
      {
        title: `${currentClub.value?.referralAlias || 'リファラル'}`,
        to: {
          name: 'waiter-settings-referrals',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'Waiter',
      },
      {
        title: '顧客タグ',
        to: {
          name: 'waiter-settings-customer-tags',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'Waiter',
      },
      {
        title: '顧客管理',
        to: {
          name: 'waiter-settings-customer-management',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'Waiter',
      },
      {
        title: '売上計上トリガー',
        to: {
          name: 'waiter-settings-vending-contribution-triggers',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'Waiter',
      },
      {
        title: 'ユーザー',
        to: {
          name: 'waiter-settings-users',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'Waiter',
      },
      {
        title: 'シフト',
        to: {
          name: 'waiter-settings-work-schedules',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'Waiter',
      },
      {
        title: '諸入費ラベル',
        to: {
          name: 'waiter-settings-book-tags',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'Admin',
      },
      {
        title: '日報β設定',
        icon: mdiFileChartPlusOutline,
        resource: 'Admin',
        to: {
          name: 'admin-report-settings',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
      },
      {
        title: `${currentClub.value?.name || '店舗'}`,
        to: {
          name: 'waiter-settings-club',
          params: {
            club_slug: currentClub.value?.slug,
          },
        },
        resource: 'Waiter',
      },
    ],
  },
]
